<template>
  <container>
    <div slot="bottom_box_content">
        <component :is="curBottomComponent"></component>
    </div>
  </container>
</template>

<script>
import Container from '@/components/common/Container'
import { sysMixins } from '@/assets/mixins/sys'
import receiptsStoreModule from '@/store/modules/receipts'

export default {
  mixins: [sysMixins],
  components: {
    Container,
    IndexTable: () => import('./components/Bottom')
  },
  created () {
    if (!this.$store.hasModule('receipts')) {
      this.$store.registerModule('receipts', receiptsStoreModule)
    }
  },
  mounted () {
    this.setShowLeftBlock(false)
    this.setShowRightBlock(false)
    this.setShowMap(false)
    this.setBottomHeight('90%')
    this.setLeftComponent('')
    this.setRightComponent('')
    this.setBottomComponent('IndexTable')
  },
  destroyed () {
    this.$store.unregisterModule('receipts')
  }
}
</script>
